// extracted by mini-css-extract-plugin
module.exports = {"container":"cardBackStack_container__3-zBa","glow":"cardBackStack_glow__1vcJD","glowFrames":"cardBackStack_glowFrames__1EVSW","cardBack":"cardBackStack_cardBack__11CjX"};